import { Navigate } from "react-router";
import Dashboard from "./views/Dashboard";
import SecondPage from "./views/SecondPage";

const BASE_PATH = "/ta-chat-assistant-fe"; // TODO: replace base path for your MFE

export const routePaths = {
  dashboard: BASE_PATH,
  secondary: `${BASE_PATH}/secondary`,
};

export const routes = [
  {
    path: "/", // It is only used for standalone app. If you want, you can remove this path.
    element: <Navigate to={BASE_PATH} replace />,
  },
  {
    path: BASE_PATH,
    children: [
      { path: "", element: <Dashboard /> },
      { path: "secondary", element: <SecondPage /> },
    ],
  },
];
